// src/utils/dailyNormPraise.js

export const DAILY_NORM_PRAISE_TEXTS = Object.freeze({
  title: "Отлично!",
  /**
   * Текст похвалы как функция от подписи даты: похвала - про
   * конкретный день (может быть не «сегодня»), поэтому «за сегодня»
   * здесь неприменимо.
   */
  message: (dateLabel) => `Вы внесли все часы за ${dateLabel}. Так держать!`,
  closeLabel: "Закрыть",
  starGlyph: "★",
});

const STORAGE_PREFIX = "dailyNormPraise";

/**
 * Чистая проверка: дневная норма достигнута.
 *
 * norm <= 0 трактуем как «нормы нет» - похвалу не показываем.
 */
export function isDailyNormComplete({ fact, norm }) {
  const f = Number(fact);
  const n = Number(norm);
  return Number.isFinite(f) && Number.isFinite(n) && n > 0 && f >= n;
}

export function dailyNormPraiseStorageKey(empId, isoDate) {
  return `${STORAGE_PREFIX}:${empId}:${isoDate}`;
}

export function hasDailyNormPraiseBeenShown(empId, isoDate) {
  try {
    if (typeof localStorage === "undefined") return false;
    return (
      localStorage.getItem(dailyNormPraiseStorageKey(empId, isoDate)) === "1"
    );
  } catch {
    return false;
  }
}

export function markDailyNormPraiseShown(empId, isoDate) {
  try {
    if (typeof localStorage === "undefined") return;
    localStorage.setItem(dailyNormPraiseStorageKey(empId, isoDate), "1");
  } catch {
    // localStorage может быть недоступен (приватный режим, ограничения
    // браузера). Молча пропускаем: сохранение часов от этого не зависит.
  }
}

/**
 * Снять отметку о показе похвалы за день.
 *
 * Нужно, когда часы за день больше не покрывают норму - например,
 * сотрудник ошибочно внёс запись в другую задачу и удалил её.
 * Тогда при повторном достижении нормы (уже в правильной задаче)
 * модалка покажется снова.
 */
export function clearDailyNormPraiseShown(empId, isoDate) {
  try {
    if (typeof localStorage === "undefined") return;
    localStorage.removeItem(dailyNormPraiseStorageKey(empId, isoDate));
  } catch {
    // См. комментарий в markDailyNormPraiseShown.
  }
}
